import React from "react";
import Dialog from "@material-ui/core/Dialog";

interface OpenState {
  setOpen: any;
  children: React.ReactNode;
  onOpen?: any;
  disabled?: boolean;
}

interface OpenProps {
  open: boolean;
  setOpen: any;
  children: React.ReactNode;
  onClose?: any;
}

export const ApolloDialogButton = ({setOpen, children, onOpen, disabled}: OpenState) => {

  const handleOpen = () => {
    if (disabled) return;
    if (onOpen && typeof onOpen === 'function') onOpen();
    setOpen(true);
  }

  return (
    <React.Fragment>
      <div onClick={handleOpen}>
        {children}
      </div>
    </React.Fragment>
  );
}

export const ApolloDialog = ({open, setOpen, children, onClose}: OpenProps) => {

  const handleClose = () => {
    if (onClose && typeof onClose === 'function') onClose();
    setOpen(false);
  }

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth={false}
      >
        {children}
      </Dialog>
    </React.Fragment>
  );
}
